import React from 'react';
import { Link } from 'react-router-dom';

interface ResourceLink {
  title: string;
  description: string;
  url: string;
  badge?: string;
}

const OtherPage: React.FC = () => {
  const resources: ResourceLink[] = [
    {
      title: 'Documentation',
      description: 'Comprehensive guides for buyers and sellers',
      url: '/docs'
    },
    {
      title: 'API Reference',
      description: 'Technical documentation for our marketplace API',
      url: '/api-docs',
      badge: 'v2.0'
    },
    {
      title: 'Developer Community',
      description: 'Join our forum to discuss and share your work',
      url: '/community'
    },
    {
      title: 'Resource Hub',
      description: 'Free resources, tutorials, and tools for developers',
      url: '/resources'
    },
    {
      title: 'Affiliate Program',
      description: 'Earn commission by referring new users',
      url: '/affiliates',
      badge: 'New'
    },
    {
      title: 'Seller Guidelines',
      description: 'Best practices for selling on our marketplace',
      url: '/seller-guidelines'
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Resources & Links</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {resources.map((resource, index) => (
            <Link
              key={index}
              to={resource.url}
              className="bg-[#1F1A27] rounded-lg p-6 flex flex-col hover:bg-[#2A2633] transition-colors"
            >
              <div className="flex items-center gap-2 mb-2">
                <h2 className="text-xl font-medium">{resource.title}</h2>
                {resource.badge && (
                  <span className="text-xs bg-[#7F56D9] text-white px-2 py-0.5 rounded-full font-medium">
                    {resource.badge}
                  </span>
                )}
              </div>
              <p className="text-[var(--color-muted)]">{resource.description}</p>
            </Link>
          ))}
        </div>

        <div className="bg-[#1F1A27] rounded-lg p-8 mb-12">
          <h2 className="text-2xl font-bold mb-6">Newsletter</h2>
          <p className="text-[var(--color-muted)] mb-6">
            Subscribe to get the latest updates and exclusive content.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              placeholder="Your email address"
              className="flex-grow py-3 px-4 bg-[#2A2633] border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-[#7F56D9]"
            />
            <button className="btn-primary py-3 px-6 sm:w-auto w-full">
              Subscribe
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#7F56D9]/20 to-[#F670C7]/20 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">Have Suggestions?</h2>
          <p className="text-[var(--color-muted)] mb-6 max-w-xl mx-auto">
            We're constantly improving our platform. If you have ideas, we'd love to hear from you!
          </p>
          <Link
            to="/contact?subject=Suggestion"
            className="btn-primary py-3 px-6 inline-block"
          >
            Share Your Ideas
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OtherPage;
